import React from 'react';
import ListItemWrapper from '../DatasetDefinitions/ListItemWrapper';
import EntityListItemLink from './EntityListItemLink';
import EntitySettingsOption from './EntitySettingsOption';
import PERMISSIONS from '../../../permissionDefinitions';
import PermissionGates from 'components/PermissionGates';
import ContextMenu from '../../../kingpin/atoms/ContextMenu';
import EntityDeleteOption from './EntityDeleteOption';
import ManageEntityAppsOption from './ManageEntityAppsOption';
import Break from '../../../kingpin/atoms/ContextMenu/Break';

const AdminMenu = ({ entity }: { entity: EntityDetails.Entity }) => {
  return (
    <ContextMenu testId={`options-${entity.id}`}>
      <EntitySettingsOption entity={entity} />
      <ManageEntityAppsOption entity={entity} />
      <Break />
      <EntityDeleteOption entity={entity} />
    </ContextMenu>
  );
};

const BasicMenu = ({ entity }: { entity: EntityDetails.Entity }) => {
  return (
    <ContextMenu testId={`options-${entity.id}`}>
      <EntitySettingsOption entity={entity} isAccessOnly />
    </ContextMenu>
  );
};

const Menu = ({ entity }: { entity: EntityDetails.Entity }) => {
  return (
    <PermissionGates.Has
      requiredPermission={PERMISSIONS.DATA_MANAGEMENT.ENTITY_CONFIGURATION}
      fallback={<BasicMenu entity={entity} />}
    >
      <AdminMenu entity={entity} />
    </PermissionGates.Has>
  );
};

const ListItem = ({ entity }: { entity: EntityDetails.Entity }) => {
  return (
    <ListItemWrapper
      style={{ justifyContent: 'space-between', alignItems: 'center' }}
    >
      <EntityListItemLink entity={entity} />
      <Menu entity={entity} />
    </ListItemWrapper>
  );
};

export default ListItem;
